// extracted by mini-css-extract-plugin
module.exports = {"advertising-mobile":"advertising_advertising-mobile__1cI_m","content":"advertising_content__XjLZ_","text":"advertising_text__iIYyU"};